<template>
  <form id="v-search" ref="v-search" method="get" v-if="loaded" @change.prevent="formChange(true)"
        @submit.prevent="formChange(false)">
    <div id="vehicle__search" :class="(payload.search === false ? 'no__grid' : '')">
      <input type="hidden" name="sortorder" :value="sorting">
      <aside v-if="(payload.search !== false)" :class="(showAside ? 'show' : '')">
        <div class="closeFilter">
          <span @click="toggleAside">+</span>
        </div>
        <div id="fixedSidebar">
          <span v-if="formSelection" class="resetFilter" @click="resetFilter">Filter zurücksetzen</span>


          <tab-component ref="tabs" :selectedTab="selectedTab">
            <tab-item :name="formSelection.hidden.includes('make') ? 'Marke & Modell' : 'Marke, Modell & Kategorie'" :count="count"
                      :selection="(formSelection && formSelection.makemodel ? formSelection.makemodel : null)"
                      @update-tab="selectTab" @hide-tab="hideTab" :selected="selectedTab">
              <div class="select-grid">
                <div class="select-comp"
                     v-if="attrs.types  && !formSelection.hidden.includes('make')">


                  <type-component
                      :options="attrs.types"
                      label="Fahrzeugtyp wählen"
                      :preselect="payload.type ? payload.type : selectedType"
                      @updateType="updateTypes"
                  />
                  <!--
                                      @inputData="updateTypes"-->
                </div>
                <div class="select-comp"
                     v-if="makes && selectedType || makes &&  formSelection.hidden.includes('make')">
                  <make-component
                      @inputData="updateModels"
                      :preselect="(payload.make ? payload.make : selectedMake)"
                      label="Marke wählen"
                      :options="makes"/>

                </div>
                <div class="select-comp" v-if="models && models.length > 0">

                  <model-component :msg="models" :payload="payload"
                                   label="Modell wählen"/>
                </div>
                <div class="select-comp" v-if="attrs.categories && selectedType">

                  <category-component
                      :preselect="payload.category ? payload.category : ''" :options="attrs.categories[selectedType]"
                      label="Kategorie wählen"/>
                </div>


                <div class="input-field">
                  <input type="text" name="internalNumber" value="" placeholder="Interne Nummer">
                </div>
              </div>
            </tab-item>
            <tab-item name="Preis & Zustand" :count="count"
                      :selection="(formSelection && formSelection.condition ? formSelection.condition : null)"
                      @update-tab="selectTab"
                      @hide-tab="hideTab" :selected="selectedTab">

              <checkbox-component v-if="attrs.conditions" name="condition[]" :preselect="payload.mobileCondition"
                                  category="condition" label="Fahrzeugzustand" :options="attrs.conditions"/>


              <checkbox-component v-if="attrs.usagetypes && ! formSelection.hidden.includes('usageType')" name="usageType[]" :preselect="payload.usageType"
                                  label="Art" :options="attrs.usagetypes" category="usagetypes"/>


              <div class="ranges">




                <range-slider-component @update-range="formChangeTest" v-for="(range, key) in ranges" :key="key"

                                        :ref="range.key"
                                        :name="range.key"
                                        :step="range.step"
                                        :label="range.label"
                                        :suffix="range.suffix"
                                        :config="attrs[range.key]"
                                        :inputMin="range.key + 'min'"
                                        :inputMax="range.key + 'max'"
                                        rkey="ranges"
                />
              </div>

            </tab-item>
            <tab-item name="Leasing" :count="count" v-if="financing &&    !formSelection.hidden.includes('make')" @update-financing="updateFinancing"  @update-tab="selectTab" @hide-tab="hideTab"
                      :selection="(formSelection && formSelection.financing ? formSelection.financing : null)"
                      :selected="selectedTab">


              <checkbox-component :selectedItem="(selectedTab == 'Leasing')" v-if="attrs.financing  && attrs.financing.type" name="financing[type][]"
                                  category="financingType"
                                  label="Typ"
                                  :options="attrs.financing.type"/>

              <div class="ranges">
                <range-slider-component @update-range="formChange" v-for="(range, key) in financing" :key="key"

                                        :ref="range.key"
                                        :name="range.key+'-financing'"
                                        :step="range.step"
                                        :label="range.label"
                                        :suffix="range.suffix"
                                        :config="attrs.financing[range.key]"
                                        :inputMin="range.key + 'financingmin'"
                                        :inputMax="range.key + 'financingmax'"
                                        rkey="financing"
                />
              </div>


            </tab-item>
            <tab-item name="Motor" :count="count"
                      :selection="(formSelection && formSelection.motor ? formSelection.motor : null)"
                      @update-tab="selectTab" @hide-tab="hideTab" :selected="selectedTab">


              <checkbox-component v-if="attrs.gearboxes" name="gearbox[]" category="gearbox" label="Getriebe"
                                  :options="attrs.gearboxes"/>
              <checkbox-component v-if="attrs.fuels" name="fuel[]" category="fuel" label="Kraftstoff"
                                  :options="attrs.fuels"/>


              <equipment-component v-if="equipments && equipments.wheels" :type="equipments.wheels" label="Antrieb"/>


              <div class="ranges">

                <range-slider-component @update-range="formChange"
                                        v-for="(range, key) in rangesMotor"
                                        :ref="range.key"
                                        :key="key"
                                        :name="range.key"
                                        :step="range.step"
                                        :label="range.label"
                                        :suffix="range.suffix"
                                        :config="attrs[range.key]"
                                        :inputMin="range.key + 'min'"
                                        :inputMax="range.key + 'max'"
                                        rkey="ranges"
                />
              </div>


            </tab-item>
            <tab-item name="Farbe" :count="count"
                      :selection="(formSelection && formSelection.color ? formSelection.color : null)"
                      @update-tab="selectTab" @hide-tab="hideTab" :selected="selectedTab">


              <div class="tab-heading">Außenfarbe</div>


              <color-component :options="attrs.colors" type="exteriorColor"/>
              <div class="tab-heading">Innenausstattung</div>
              <color-component :options="attrs.interiorcolors" type="interiorColor"/>


            </tab-item>
            <tab-item name="Ausstattung" :count="count" @update-tab="selectTab" @hide-tab="hideTab"
                      :selection="(formSelection && formSelection.equipments ? formSelection.equipments : null)"
                      :selected="selectedTab">


              <equipment-component v-if="equipments && equipments.exterior" :type="equipments.exterior"
                                   label="Exterieur"/>
              <equipment-component v-if="equipments && equipments.audio" :type="equipments.audio"
                                   label="Audio und Kommunikation"/>
              <equipment-component v-if="equipments && equipments.interior" :type="equipments.interior"
                                   label="Interieur"/>

              <checkbox-component v-if="attrs.interiortypes" name="interiorType[]" category="interiorType"
                                  label="Interieur Material" :options="attrs.interiortypes"/>


              <equipment-component v-if="equipments && equipments.assistents" :type="equipments.assistents"
                                   label="Assistenzsysteme"/>

              <equipment-component v-if="equipments && equipments.others" :type="equipments.others"
                                   label="Weitere Merkmale"/>


            </tab-item>
            <tab-item name="Standort" :count="count" @update-tab="selectTab"
                      :selection="(formSelection && formSelection.seller ? formSelection.seller : null)"
                      @hide-tab="hideTab"
                      :selected="selectedTab">

              <div class="select-comp">
                <seller-component
                    :preselect="payload.seller ? payload.seller : ''"
                    label="Standort wählen"
                    :options="attrs.sellers"
                    v-if="attrs.sellers"/>

              </div>


            </tab-item>
          </tab-component>
        </div>

      </aside>
      <main id="results">

        <div class="aside__handler grid-container" v-if="loaded">


          <div class="formResult">
            <h2>Wir haben <b>{{ count }} <span v-if="count > 1">Fahrzeuge</span><span v-else>Fahrzeug</span></b> für Sie
              gefunden</h2>
          </div>

          <div class="filterAction">
            <span @click="toggleAside">Filter hinzufügen</span>
          </div>

          <div class="formAction">
            <div id="vehicle-sorting">



            <span class="select-component" id="sort">
          <select name="order" class="sort" @change="sortOrder">
            <option v-for="(key, index ) in attrs.sorting" data-label="value"
                    :selected="(formSelection && formSelection.sortorder && formSelection.sortorder === (key.name + '|' + key.direction))"
                    :key="index" :value="key.name + '|' + key.direction">
              {{ key.label }}
            </option>
          </select>
        </span>


            </div>
          </div>


        </div>

        <vehicle-component :vehicles-arr="vehicles" :hasAction="formSelection.hidden.includes('make')" :banner="banner"></vehicle-component>
      </main>
    </div>
  </form>
</template>

<script>
import axios from "axios";
import Tab from "@/components/Tab";
import RangeSlider from "@/components/RangeSlider";
import Checkbox from "@/components/Checkbox";
import Make from "@/components/Make";
import Model from "@/components/Model";
import Type from "@/components/Type";
import Equipment from "@/components/Equipment";
import Color from "@/components/Color";
import Seller from "@/components/Seller";
import Category from "@/components/Category";
import TabItem from "@/components/TabItem";
import Vehicle from "@/components/Vehicle";

function getUrlParams(search) {
  let hashes = search.slice(search.indexOf('?') + 1).split('&')
  return hashes.reduce((params, hash) => {

    let [key, val] = hash.split('=')
    if (key) {
      return Object.assign(params, {[key]: decodeURIComponent(val)})
    } else {
      return false
    }
  }, {})
}

function goTo(page, title, url) {
  if ("undefined" !== typeof history.pushState) {
    history.pushState({
      page: page
    }, title, url);
  } else {
    window.location.assign(url);
  }
}

let payload = {}
let marketplace = ''
let bannerData = ''
/*eslint-disable no-undef*/

if (typeof payloadData !== undefined) {
  payload = payloadData;
} else {
  payload = {};
}

if (typeof marketplaceId !== undefined) {
  marketplace = marketplaceId;
} else {
  marketplace = '';
}


if (typeof banner === undefined) {
  bannerData = '';
}else{
  bannerData = banner
}
/*eslint-enable no-undef*/

const baseUrl = 'https://www.schneidergruppe.de/api/vehicles'
const searchUrl = ''

export default {
  name: 'Search',
  components: {
    'TabComponent': Tab,
    'TabItem': TabItem,
    'CheckboxComponent': Checkbox,
    'MakeComponent': Make,
    'ModelComponent': Model,
    'VehicleComponent': Vehicle,
    'RangeSliderComponent': RangeSlider,
    'TypeComponent': Type,
    'CategoryComponent': Category,
    'SellerComponent': Seller,
    'ColorComponent': Color,
    'EquipmentComponent': Equipment

  },
  data() {
    return {
      models: [],
      banner: bannerData,
      sortorder: [
        {
          "asc": "absteigend"
        },
        {
          "desc": "aufsteigend"
        }
      ],
      sorting: "",
      showAside: false,
      makes: [],
      selectedTab: '',
      equipments: [],
      attrs: {},
      formSelection: null,
      count: 0,
      loaded: false,
      payload: payload,
      selectedType: '',
      selectedMake: '',
      errored: false,
      vehicles: this.$store.state,
      selections: [{
        "key": "usagetypes",
        "label": "Usagetype wählen"
      }, {
        "key": "airbags",
        "label": "Airbag wählen"
      }, {
        "key": "climatisations",
        "label": "Klima wählen"
      }, {
        "key": "conditions",
        "label": "Fahrzeugzustand wählen"
      }, {
        "key": "fuels",
        "label": "Karaftstoffart wählen"
      }, {
        "key": "gearboxes",
        "label": "Getriebeart wählen"
      }, {
        "key": "interiortypes",
        "label": "Innenausttatung wählen"
      }],
      ranges: [{
        "key": "mileage",
        "label": "Kilometerstand",
        "step": 1,
        "suffix": "km",
        "options": [
            5000,
            10000,
            20000,
            30000,
            40000,
            50000,
            60000,
            70000,
            80000,
            90000,
            100000,
            125000,
            150000
        ]
      }, {
        "key": "registrationYear",
        "label": "Erstzulassung",
        "step": 1,
        "options": this.years(1960)
      }, {
        "key": "consumerPriceGross",
        "label": "Preis",
        "step": 1,
        "suffix": "€",
        "options": [
            500,
            1000,
            1500,
            2000,
            2500,
            3000,
            3500,
            4000,
            4500,
            5000,
            6000,
            7000,
            8000,
            9000,
            10000,
            11000,
            12000,
            13000,
            14000,
            15000,
            16000,
            17000,
            18000,
            19000,
            20000,
            22500,
            25000,
            27500,
            30000,
            35000,
            40000,
            45000,
            50000,
            55000,
            60000,
            70000,
            80000,
            90000,
            100000
        ]
      }],
      financing: [{
        "key": "mileage",
        "label": "Gesamtfahrleistung",
        "step": 1,
        "suffix": "km"
      }, {
        "key": "rate",
        "label": "Leasingrate",
        "step": 1,
        "suffix": "â‚¬"
      }, {
        "key": "runtime",
        "label": "Laufzeit in Monaten",
        "step": 1,
        "suffix": "Monate"
      }],
      rangesMotor: [{
        "key": "ps",
        "label": "Leistung",
        "step": 1,
        "suffix": "PS"
      }]

    }
  },
  methods: {
    selectTab(e) {
      this.selectedTab = e

    },
    years(startYear) {
      const currentYear = new Date().getFullYear(), years = [];
      startYear = startYear || 1980;
      while ( startYear <= currentYear ) {
        years.push(startYear++);
      }
      return years;
    },
    toggleAside(){
      if(this.showAside === true){
        this.showAside = false
      }else{
        this.showAside = true
      }
    },
    hideTab() {
      this.selectedTab = null
      this.showAside = false

    },
    sortOrder(s) {

      console.log(s)
      this.sorting = s.target.value
      const _this = this;
      setTimeout(function () {
        _this.formChange(false)
      }, 100)

    },
    updateForm(e) {
      console.log(e)
    },
    updateModels(variable) {
      if (this.selectedType) {
        if (this.makes[variable]) {
          const filtered = this.makes[variable].filter(function (el) {
            return el !== "" && el !== null;
          });

          if (filtered.length > 0) {
            this.models = filtered;
          } else {
            this.models = false;
          }
        } else {
          this.models = false;
        }
      }

    },

    updateTab() {

    },


    updateSortDirection(direction) {
      document.getElementById("orderinput").value = direction;
      this.formChange(false);
    },
    updateTypes(variable) {
      this.selectedMake = ''

      if (variable) {
        this.equipments = this.attrs.features[variable];

        this.makes = this.attrs.makes[variable];



        this.selectedType = variable;

        if (document.getElementById('make')) {

          const selMake = document.getElementById('make').value;

          if (this.attrs.makes[variable][selMake]) {
            const filtered = this.attrs.makes[variable][selMake].filter(function (el) {
              return el !== "" && el !== null;
            });


            if (filtered.length > 0) {
              this.models = filtered;
            } else {
              this.models = false;
            }
          } else {
            this.models = false;
          }

        }
      }

    },

    updateFinancing(){
      let _this = this
      setTimeout(function(){
        _this.formChange()
      }, 100)
    },


    resetFilter() {
      this.$refs['v-search'].reset();
      const clean_uri = location.protocol + "//" + location.host + location.pathname;
      window.history.replaceState({}, document.title, clean_uri);
      location.reload()
    },
    formChangeTest() {

      this.formChange(false)
    },
    formChange(counting = false) {

      let index = 0;

      const _this4 = this;
      const formData = new FormData(this.$refs['v-search']);
      let data = {};
      for (let [key, val] of formData.entries()) {

        if (val !== "") {
          key = key.replace("[]", "[" + index + "]")
          Object.assign(data, {
            [key]: val
          });
          index++;
        }


      }
      if(payload.search === false || payload.makes){
        data = Object.assign(data, payload);
      }

      const queryString = Object.keys(data).map(function (key) {
        return key + '=' + data[key];
      }).join('&');

      this.$store.changeQuery("?" + queryString)

      goTo("v-search-coffi", "vehicle search", searchUrl + "?" + queryString)


      axios.get(baseUrl + '/search' +(marketplace ? '/' + marketplace : ''), {
        params: data
      })
          .then(response => {
            _this4.vehicles = response.data;
            _this4.count = response.data.count;
            _this4.formSelection = response.data.selection

            console.log(counting);
            //if (!counting) { //}
              _this4.$store.addVehicles(_this4.vehicles)



          })
          .catch(error => console.log(error))
          .finally(() => _this4.loaded = true);
    },
  },
  created() {
    let urlParams = getUrlParams(window.location.search)



    if(! urlParams){
      urlParams = payload
    }

    let queryString = Object.keys(urlParams).map(key => key + '=' + urlParams[key]).join('&');

    this.$store.changeQuery("?" + queryString)
    goTo("v-search-coffi", "vehicle search", searchUrl + "?" + queryString)

    axios.get(baseUrl + "/attributes" + (marketplace ? '/' + marketplace : '') + (urlParams ? '?' + queryString : ''))
        .then(response => {
          this.attrs = response.data;

          if( response.data.selection.hidden && response.data.selection.hidden.includes('make')){

            let preMakes = {}
            for(const make in response.data.makes[response.data.params.type]){
              if(response.data.selection.params.makes.includes(make)){
                preMakes[make] =  response.data.makes[response.data.params.type][make]
              }

            }
            console.log(this.makes)
            this.makes = preMakes

            this.selectedType = response.data.params.type;
          }else{
            this.makes = response.data.makes;

          }
          this.payload = response.data.params
        })
        .catch(error => console.log(error));


    axios.get(baseUrl + '/search' +(marketplace ? '/' + marketplace : ''), {
      params: (urlParams ? urlParams : '')
    })
        .then(response => {
          this.vehicles = response.data;
          this.formSelection = response.data.selection;
          this.count = response.data.count;
          this.$store.addVehicles(this.vehicles);
        })
        .catch(error => console.log(error))
        .finally(() => this.loaded = true);


  }
}
</script>
<style lang="scss">

#vehicle__search {
  width: 100%;
  display: grid;
  grid-template-columns: 0.75fr 3fr;
  grid-gap: 30px;

  &.no__grid {

    grid-template-columns: 1fr;
  }

  aside {

    #fixedSidebar {
      position: -webkit-sticky;
      position: sticky;
      top: 120px;
      z-index: 2;
    }


    * {
      box-sizing: border-box;
    }

    .tabs {
      .tab-item {
        padding: 12px 0;
        border-bottom: 1px solid #efefef;
      }

      .tab-item-content {
        margin-top: 20px;
      }
    }
  }
}

.rentThisCar {
  margin-top: 20px;
  background: #fcc312;
  display: inline-block;
  padding: 10px 14px;
  color: #111;
  border: none;
  text-decoration: none;
  font-size: 14px;
  cursor: pointer;
  transition: box-shadow .3s;
}

.rent-modal {
  width: 100%;
  position: relative;
  background: #fcc312;
  box-sizing: border-box;
  padding: 30px;
  margin-top: 30px;
}

.rent-close {
  position: absolute;
  right: 30px;
  top: 18px;
  cursor: pointer;
  font-size: 40px;
  transform: rotate(45deg);
}

.rent-heading {
  font-size: 24px;
  font-weight: 700;
  margin: 0 10px 30px 10px;
}

.rent-modal.active {
  display: block;
}

.rent-content {
  display: grid;
  grid-template-columns: repeat(5, 1fr);

  .rent-package {
    box-sizing: border-box;
    text-align: center;
    padding: 0 10px;

    h3 {
      font-size: 22px;
    }

    .rent_km {
      font-size: 12px;
    }

    .rent_price {
      font-weight: bold;
      font-size: 18px;
    }
  }

  .button {
    margin-top: 20px;
    background: #111;
    display: inline-block;
    padding: 10px 14px;
    color: #fcc312 !important;
    border-radius: 25px;
    border: none;
    text-decoration: none;
    font-size: 14px;
    cursor: pointer;
    transition: box-shadow .3s;
  }
}

@media (max-width: 900px) {
  .rent-content {
    display: block;

    .rent-package {
      width: 50%;
      float: left;
    }
  }

  .rent-heading {
    font-size: 18px;
    max-width: 70%;
  }
}

.slbOverlay, .slbWrapOuter, .slbWrap {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.slbOverlay {
  overflow: hidden;
  z-index: 2000;
  background-color: #000;
  opacity: 0.7;
  -webkit-animation: slbOverlay 0.5s;
  -moz-animation: slbOverlay 0.5s;
  animation: slbOverlay 0.5s;
}

.slbWrapOuter {
  overflow-x: hidden;
  overflow-y: auto;
  z-index: 2010;
}

.slbWrap {
  position: absolute;
  text-align: center;

  &:before {
    content: "";
    display: inline-block;
    height: 100%;
    vertical-align: middle;
  }
}

.slbContentOuter {
  position: relative;
  display: inline-block;
  vertical-align: middle;
  margin: 0px auto;
  padding: 0 1em;
  box-sizing: border-box;
  z-index: 2020;
  text-align: left;
  max-width: 100%;
}

.slbContentEl .slbContentOuter {
  padding: 5em 1em;
}

.slbContent {
  position: relative;
}

.slbContentEl .slbContent {
  -webkit-animation: slbEnter 0.3s;
  -moz-animation: slbEnter 0.3s;
  animation: slbEnter 0.3s;
  background-color: #fff;
  box-shadow: 0 0.2em 1em rgba(0, 0, 0, 0.4);
}

.slbImageWrap {
  -webkit-animation: slbEnter 0.3s;
  -moz-animation: slbEnter 0.3s;
  animation: slbEnter 0.3s;
  position: relative;

  &:after {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    top: 5em;
    bottom: 5em;
    display: block;
    z-index: -1;
    box-shadow: 0 0.2em 1em rgba(0, 0, 0, 0.6);
    background-color: #FFF;
  }
}

.slbDirectionNext .slbImageWrap {
  -webkit-animation: slbEnterNext 0.4s;
  -moz-animation: slbEnterNext 0.4s;
  animation: slbEnterNext 0.4s;
}

.slbDirectionPrev .slbImageWrap {
  -webkit-animation: slbEnterPrev 0.4s;
  -moz-animation: slbEnterPrev 0.4s;
  animation: slbEnterPrev 0.4s;
}

.slbImage {
  width: auto;
  max-width: 100%;
  height: auto;
  display: block;
  line-height: 0;
  box-sizing: border-box;
  padding: 5em 0;
  margin: 0 auto;
}

.slbCaption {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-wrap: normal;
  font-size: 1.4em;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 0.71429em 0;
  color: #fff;
  color: rgba(255, 255, 255, 0.7);
  text-align: center;
}

.slbCloseBtn, .slbArrow {
  margin: 0;
  padding: 0;
  border: 0;
  cursor: pointer;
  background: none;
}

.slbCloseBtn::-moz-focus-inner, .slbArrow::-moz-focus-inner {
  padding: 0;
  border: 0;
}

.slbCloseBtn:hover, .slbArrow:hover {
  opacity: 0.5;
}

.slbCloseBtn:active, .slbArrow:active {
  opacity: 0.8;
}

.slbCloseBtn {
  -webkit-animation: slbEnter 0.3s;
  -moz-animation: slbEnter 0.3s;
  animation: slbEnter 0.3s;
  font-size: 3em;
  width: 1.66667em;
  height: 1.66667em;
  line-height: 1.66667em;
  position: absolute;
  right: -0.33333em;
  top: 0;
  color: #fff;
  color: rgba(255, 255, 255, 0.7);
  text-align: center;
}

.slbLoading .slbCloseBtn {
  display: none;
}

.slbLoadingText {
  font-size: 1.4em;
  color: #fff;
  color: rgba(255, 255, 255, 0.9);
}

.slbArrows {
  position: fixed;
  top: 50%;
  left: 0;
  right: 0;
}

.slbLoading .slbArrows {
  display: none;
}

.slbArrow {
  position: absolute;
  top: 50%;
  margin-top: -5em;
  width: 5em;
  height: 10em;
  opacity: 0.7;
  text-indent: -999em;
  overflow: hidden;

  &:before {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    margin: -0.8em 0 0 -0.8em;
    border: 0.8em solid transparent;
  }

  &.next {
    right: 0;

    &:before {
      border-left-color: #fff;
    }
  }

  &.prev {
    left: 0;

    &:before {
      border-right-color: #fff;
    }
  }
}

.slbIframeCont {
  width: 80em;
  height: 0;
  overflow: hidden;
  padding-top: 56.25%;
  margin: 5em 0;
}

.slbIframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  box-shadow: 0 0.2em 1em rgba(0, 0, 0, 0.6);
  background: #000;
}

@-webkit-keyframes slbOverlay {
  from {
    opacity: 0;
  }

  to {
    opacity: 0.7;
  }
}

@-moz-keyframes slbOverlay {
  from {
    opacity: 0;
  }

  to {
    opacity: 0.7;
  }
}

@keyframes slbOverlay {
  from {
    opacity: 0;
  }

  to {
    opacity: 0.7;
  }
}

@-webkit-keyframes slbEnter {
  from {
    opacity: 0;
    -webkit-transform: translate3d(0, -1em, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: translate3d(0, 0, 0);
  }
}

@-moz-keyframes slbEnter {
  from {
    opacity: 0;
    -moz-transform: translate3d(0, -1em, 0);
  }

  to {
    opacity: 1;
    -moz-transform: translate3d(0, 0, 0);
  }
}

@keyframes slbEnter {
  from {
    opacity: 0;
    -webkit-transform: translate3d(0, -1em, 0);
    -moz-transform: translate3d(0, -1em, 0);
    -ms-transform: translate3d(0, -1em, 0);
    -o-transform: translate3d(0, -1em, 0);
    transform: translate3d(0, -1em, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: translate3d(0, 0, 0);
    -moz-transform: translate3d(0, 0, 0);
    -ms-transform: translate3d(0, 0, 0);
    -o-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

@-webkit-keyframes slbEnterNext {
  from {
    opacity: 0;
    -webkit-transform: translate3d(4em, 0, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: translate3d(0, 0, 0);
  }
}

@-moz-keyframes slbEnterNext {
  from {
    opacity: 0;
    -moz-transform: translate3d(4em, 0, 0);
  }

  to {
    opacity: 1;
    -moz-transform: translate3d(0, 0, 0);
  }
}

@keyframes slbEnterNext {
  from {
    opacity: 0;
    -webkit-transform: translate3d(4em, 0, 0);
    -moz-transform: translate3d(4em, 0, 0);
    -ms-transform: translate3d(4em, 0, 0);
    -o-transform: translate3d(4em, 0, 0);
    transform: translate3d(4em, 0, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: translate3d(0, 0, 0);
    -moz-transform: translate3d(0, 0, 0);
    -ms-transform: translate3d(0, 0, 0);
    -o-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

@-webkit-keyframes slbEnterPrev {
  from {
    opacity: 0;
    -webkit-transform: translate3d(-4em, 0, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: translate3d(0, 0, 0);
  }
}

@-moz-keyframes slbEnterPrev {
  from {
    opacity: 0;
    -moz-transform: translate3d(-4em, 0, 0);
  }

  to {
    opacity: 1;
    -moz-transform: translate3d(0, 0, 0);
  }
}

@keyframes slbEnterPrev {
  from {
    opacity: 0;
    -webkit-transform: translate3d(-4em, 0, 0);
    -moz-transform: translate3d(-4em, 0, 0);
    -ms-transform: translate3d(-4em, 0, 0);
    -o-transform: translate3d(-4em, 0, 0);
    transform: translate3d(-4em, 0, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: translate3d(0, 0, 0);
    -moz-transform: translate3d(0, 0, 0);
    -ms-transform: translate3d(0, 0, 0);
    -o-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}


@media (max-width: 1024px) {


  #container p img {
    width: 100%;
    height: auto;
  }
}

.widget #vehicle__search {
  width: 100%;
  border-sizing: border-box;

  form {
    padding: 20px;
    background: #efefef;

    .select-style {
      margin-bottom: 12px;
    }
  }
}

#vehicle__search {
  .vehicle-detail {
    .price {
      float: right;
      width: 30%;
      text-align: right;
    }

    .default-info {
      width: 70%;
      float: left;
    }

    .pricing {
      display: block;
      vertical-align: top;
    }

    .price .pricing {
      margin-top: 3px;
    }
  }

  #leasing-overview {
    margin-bottom: 30px;
  }

  .dots-wrapper {
    position: absolute;
    width: 100px;
    left: 50%;
    margin-left: -50px;
    bottom: 20px;
    text-align: center;

    li {
      display: inline-block;
      width: 12px;
      height: 12px;
      background-color: white;
      border-radius: 50%;
      margin: 0 4px;
      opacity: 0.5;
      cursor: pointer;
      -webkit-transition: opacity 0.3s;
      transition: opacity 0.3s;

      &.active, &:hover {
        opacity: 1;
      }
    }
  }

  .images {

    .slider {
      position: relative;
      width: 100%;
      min-height: 100vh;
      text-align: center;
      margin: 0 auto;
      cursor: pointer;
      overflow: hidden;

      .slider-inner {
        position: absolute;

        &:after {
          content: "";
          display: table;
          clear: both;
        }

        .slide {
          float: left;
          box-sizing: border-box;
          background-size: 100% auto;
          background-attachment: fixed;
          background-position: center center;

          img {
            display: block;
            width: 100%;
          }

          span {
            cursor: default;
            -webkit-touch-callout: none;
            -webkit-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;
            user-select: none;
            display: block;
            width: 100vw;
            height: 100vh;
            top: 12vw;
            font-size: 10vw;
            line-height: 100vh;
            letter-spacing: 1vw;
            font-family: Impact, Charcoal, sans-serif;
            text-shadow: 5px 5px 0px #ffffff;
          }
        }
      }
    }
  }

  a[class|="arrow"] {
    position: absolute;
    display: block;
    top: 50%;
    margin-top: -20px;
    width: 40px;
    height: 40px;
  }

  .arrow-left {
    left: 20px;
    border-bottom: 6px solid #ffffff;
    border-left: 6px solid #ffffff;
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
    -webkit-transition: left 0.5s;
    transition: left 0.5s;

    &:hover {
      left: 15px;
    }
  }

  .arrow-right {
    right: 20px;
    border-bottom: 6px solid #ffffff;
    border-right: 6px solid #ffffff;
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
    -webkit-transition: right 0.5s;
    transition: right 0.5s;

    &:hover {
      right: 15px;
    }
  }

  select {
    -webkit-appearance: none;
    -moz-appearance: none;
    -ms-appearance: none;
    appearance: none;
    outline: 0;
    box-shadow: none;
    border: 0 !important;
    background: #fff;
    border-radius: 0;
    font-size: 14px;
    background-image: none;

    &::-ms-expand {
      display: none;
    }
  }

  .select-component {
    position: relative;
    display: flex;
    width: 100%;
    height: 44px;
    border: 1px solid #dadada;
    line-height: 3;
    overflow: hidden;
  }

  select {
    flex: 1;
    padding: 0 .5em;
    color: #222;
    cursor: pointer;
  }

  .select-component {
    &::after {
      content: '\2058';
      position: absolute;
      top: 0;
      right: 0;
      line-height: 45px;
      padding: 0 1em;
      cursor: pointer;
      pointer-events: none;
      -webkit-transition: .25s all ease;
      -o-transition: .25s all ease;
      transition: .25s all ease;
    }

    &:hover::after {
      color: #f39c12;
    }
  }

  .vehicle-detail {
    hr {
      width: 100%;
      border: none;
      height: 0px;
      border-top: 1px solid #dadada;
      margin: 40px 0;
    }

    h2 {
      border-bottom: none;
      text-transform: none;
      letter-spacing: 0;
      font-size: 24px;
      margin-bottom: 32px;
    }

    h1 {
      font-size: 24px;
      margin-top: 0;
      margin-bottom: 30px;
    }
  }

  .imageList {
    position: relative;

    #showAllPhotos {
      position: absolute;
      background: #fff;
      color: #222;
      padding: 8px 16px;
      bottom: 50px;
      left: 50px;
      cursor: pointer;
    }
  }

  .feature-col {
    width: 50%;
    float: left;

    &.full {
      span {
        &:after {
          content: ", ";
        }

        &:last-of-type:after {
          content: "";
        }
      }

      width: 100%;
    }
  }

  .imageList {
    img {
      width: 100%;
      float: left;
    }

    figure {
      margin: 0;
      padding: 0;
    }

    .slide {
      width: 33.3333333333%;
      float: left;
      margin: 0;
      padding: 0;
    }

    a {
      display: none;

      &.showImage {
        display: block;
      }
    }

    .slide {
      &:nth-child(4), &:nth-child(5), &:nth-child(6), &:nth-child(7) {
        width: 16.6666666666%;
      }
    }
  }

  .pricing-buttons {
    margin-top: 30px;
  }

  .price-button {
    color: #fff;
    margin-bottom: 10px;
    background: #222;
    text-decoration: none;
    padding: 8px 16px;
    display: inline-block;
    margin-left: 12px;
  }

  .vehicle-general-icons {
    text-align: center;

    .icon {
      padding: 30px;
      display: inline-block;
      width: auto;
      height: auto;
      min-height: inherit !important;
      position: static;
      top: auto;
      display: inline-block !important;
      background-size: inherit;
    }

    .ico {
      width: 50px;
      height: 50px;
      display: inline-block;
      margin-bottom: 20px;
      margin-bottom: 20px;

      &.rounded {
        border-radius: 50%;
        background: #efefef;
      }

      svg {
        fill: #959899;
        color: #959899;
        width: 42px;
        height: auto;
      }
    }

    .icon-label {
      display: block;
      line-height: 1.4;
      font-size: 14px;
    }

    .icon-desc {
      display: block;
      line-height: 1.4;
      font-size: 14px;

      span {
        line-height: 1.4;
        font-size: 14px;
      }
    }

    .icon-label {
      color: #666;
      font-size: 14px;
      margin-bottom: 4px;
    }
  }

  .general-infos {
    margin-top: 40px;
  }

  .vehicle .l, .vehicle-detail .l {
    float: left;
    margin-right: 20px;
    padding-right: 20px;
    margin-bottom: 10px;
    border-right: 1px solid #dadada;
  }

  .vehicle .l:last-of-type, .vehicle-detail .l:last-of-type {
    border-right: none;
    margin-right: 0;
    padding-right: 0;
  }

  .vehicle .l span {
    color: #959899;
    display: block;
    margin-bottom: 4px;
  }

  .vehicle-detail {
    .l span {
      color: #959899;
      display: block;
      margin-bottom: 4px;
    }

    .info {
      margin-top: 0px;
      max-width: 80%;
    }
  }

  .vehicle .content p, .vehicle-detail .info p {
    font-size: 12px;
    color: #959899;
  }

  .price {
    margin-top: 30px;

    .vat {
      font-size: 12px;
      display: block;
      color: #585858;
    }

    .pricing {
      font-weight: 700;
      font-size: 26px;
      margin-top: 30px;
    }
  }

  .vehicle-detail .price .financing {
    margin-top: 15px;
    display: block;
  }

  .price-group {
    display: inline-block;

    &.finance {
      position: relative;
      padding-left: 30px;

      &:before {
        content: " / ";
        position: absolute;
        left: 0;
        display: inline-block;
        margin: 0 6px;
        color: #ccc;
        font-weight: 700;
        font-size: 32px;
      }
    }
  }

  .price .financing {
    font-weight: 700;
    font-size: 32px;
    color: #af2d00;
    margin-top: 30px;
  }


  .vehicle {

    border-bottom: 1px solid #dadada;
    padding-bottom: 40px;
    margin-bottom: 40px;
    grid-gap: 30px;
    display: grid;
    grid-template-columns: 1.5fr 3fr;
    grid-template-areas:
    "vehicleImage vehicleData"
    "rentalInfo rentalInfo";
  }

  .vehicleImage {
    grid-area: vehicleImage;
  }

  .vehicleData {
    grid-area: vehicleData;
  }

  .rentalInfo {
    grid-area: rentalInfo;
  }

  @media all and (-ms-high-contrast: none) {
    .vehicle {
      display: -ms-grid;
      -ms-grid-columns: 1.5fr 3fr;
    }

    .vehicleImage {
      -ms-grid-row: 1;
      -ms-grid-row-span: 1;
      -ms-grid-column: 1;
      -ms-grid-column-span: 1;
    }

    .vehicleData {
      -ms-grid-row: 1;
      -ms-grid-row-span: 1;
      -ms-grid-column: 2;
      -ms-grid-column-span: 1;
    }

    .rentalInfo {
      -ms-grid-row: 2;
      -ms-grid-row-span: 1;
      -ms-grid-column: 1;
      -ms-grid-column-span: 2;
    }
  }


  .services {
    margin-top: 25px;
    margin-bottom: 0;
  }

}


section #vehicle__search {
  .financing-list-head {
    margin-top: 20px;
    border-bottom: 1px solid #eee;
  }

  .financing-list {
    border-bottom: 1px solid #eee;

    small span {
      display: block;
    }

    &:last-of-type {
      border-bottom: 0;
    }
  }

  .financing-list-head li, .financing-list li {
    padding: 12px 0;
  }
}

#vehicle__search {
  .financing-list-head, .financing-list {
    width: 100%;
  }

  .financing-list-head, .financing-list {
    margin: 0;
    padding: 0;
    list-style: none;

    li {
      margin: 0;
      padding: 0;
      list-style: none;
    }
  }

  .financing-list-head li, .financing-list li {
    width: 16.6666666667%;
    float: left;
  }
}

.hideIfMobile {
  display: inline-block;
}

.showIfMobile {
  display: none;
}

@media (max-width: 650px) {
  .hideIfMobile {
    display: none;
  }

  .showIfMobile {
    display: inline-block;
  }
}

#vehicle__search .quicksearch button {
  height: 39px;
  margin-top: 0;
  border: none;
  float: left;
  margin: 0;
  height: 46px;
  display: block;
  color: #fff;
  width: 100%;
  background: #212121;
}

.showMore {
  float: right;
  margin-top: 15px;
  .button{
    margin-left: 12px;
  }
}

#vehicle__search {
  button:hover, .moreVehicles:focus {
    box-shadow: 0 0 11px rgba(33, 33, 33, 0.2);
  }

  .input-field input {
    position: relative;
    display: flex;
    width: 100%;
    height: 44px;
    border: 1px solid #dadada;
    line-height: 3;
    overflow: hidden;
    padding: 0 .5em;
    font-size: 1rem;
  }

  #locationScroll {
    display: block;
  }

  .feature-list {
    margin-bottom: 40px;

    h3 {
      letter-spacing: 0;
      margin: 0;
      background: none;
      text-align: left;
      padding: 0;
      text-transform: none;
      color: #121212;
      margin-bottom: 12px;
    }

    ul {
      padding-left: 16px;
      margin-bottom: 21px;
    }
  }

  .feature-col ul, .vehicle-body ul {
    padding-left: 16px;
    margin-bottom: 21px;
  }

  .feature-col p, .feature-list p, .vehicle-body p {
    margin-bottom: 21px;
  }

  .choices {
    position: relative;
    margin-bottom: 24px;
    font-size: 16px;

    &:focus {
      outline: none;
    }

    &:last-child {
      margin-bottom: 0;
    }

    &.is-disabled {
      .choices__inner, .choices__input {
        background-color: #eaeaea;
        cursor: not-allowed;
        -webkit-user-select: none;
        -ms-user-select: none;
        user-select: none;
      }

      .choices__item {
        cursor: not-allowed;
      }
    }

    [hidden] {
      display: none !important;
    }

    &[data-type*='select-one'] {
      cursor: pointer;

      .choices__inner {
        padding-bottom: 7.5px;
      }

      .choices__input {
        display: block;
        width: 100%;
        padding: 10px;
        border-bottom: 1px solid #dddddd;
        background-color: #ffffff;
        margin: 0;
      }

      .choices__button {
        background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMSAyMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSIjMDAwIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0yLjU5Mi4wNDRsMTguMzY0IDE4LjM2NC0yLjU0OCAyLjU0OEwuMDQ0IDIuNTkyeiIvPjxwYXRoIGQ9Ik0wIDE4LjM2NEwxOC4zNjQgMGwyLjU0OCAyLjU0OEwyLjU0OCAyMC45MTJ6Ii8+PC9nPjwvc3ZnPg==);
        padding: 0;
        background-size: 8px;
        position: absolute;
        top: 50%;
        right: 0;
        margin-top: -10px;
        margin-right: 25px;
        height: 20px;
        width: 20px;
        border-radius: 10em;
        opacity: 0.5;

        &:hover {
          opacity: 1;
        }

        &:focus {
          opacity: 1;
          box-shadow: 0px 0px 0px 2px #00bcd4;
        }
      }

      .choices__item[data-value=''] .choices__button {
        display: none;
      }

      &:after {
        content: '';
        height: 0;
        width: 0;
        border-style: solid;
        border-color: #333333 transparent transparent transparent;
        border-width: 5px;
        position: absolute;
        right: 11.5px;
        top: 50%;
        margin-top: -2.5px;
        pointer-events: none;
      }

      &.is-open:after {
        border-color: transparent transparent #333333 transparent;
        margin-top: -7.5px;
      }

      &[dir='rtl'] {
        &:after {
          left: 11.5px;
          right: auto;
        }

        .choices__button {
          right: auto;
          left: 0;
          margin-left: 25px;
          margin-right: 0;
        }
      }
    }

    &[data-type*='select-multiple'] .choices__inner, &[data-type*='text'] .choices__inner {
      cursor: text;
    }

    &[data-type*='select-multiple'] .choices__button, &[data-type*='text'] .choices__button {
      position: relative;
      display: inline-block;
      margin-top: 0;
      margin-right: -4px;
      margin-bottom: 0;
      margin-left: 8px;
      padding-left: 16px;
      border-left: 1px solid #008fa1;
      background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMSAyMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSIjRkZGIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0yLjU5Mi4wNDRsMTguMzY0IDE4LjM2NC0yLjU0OCAyLjU0OEwuMDQ0IDIuNTkyeiIvPjxwYXRoIGQ9Ik0wIDE4LjM2NEwxOC4zNjQgMGwyLjU0OCAyLjU0OEwyLjU0OCAyMC45MTJ6Ii8+PC9nPjwvc3ZnPg==);
      background-size: 8px;
      width: 8px;
      line-height: 1;
      opacity: 0.75;
      border-radius: 0;
    }

    &[data-type*='select-multiple'] .choices__button {
      &:hover, &:focus {
        opacity: 1;
      }
    }

    &[data-type*='text'] .choices__button {
      &:hover, &:focus {
        opacity: 1;
      }
    }
  }

  .choices__inner {
    display: inline-block;
    vertical-align: top;
    width: 100%;
    padding: 7.5px 7.5px 3.75px;
    border: 1px solid #dddddd;
    font-size: 14px;
    overflow: hidden;
  }

  .is-focused .choices__inner {
    border-color: #b7b7b7;
  }

  .is-open .choices__inner {
    border-color: #b7b7b7;
    border-radius: 2.5px 2.5px 0 0;
  }

  .is-flipped.is-open .choices__inner {
    border-radius: 0 0 2.5px 2.5px;
  }

  .choices__list {
    margin: 0;
    padding-left: 0;
    list-style: none;
  }

  .choices__list--single {
    display: inline-block;
    padding: 4px 16px 4px 4px;
    width: 100%;
  }

  [dir='rtl'] .choices__list--single {
    padding-right: 4px;
    padding-left: 16px;
  }

  .choices__list--single .choices__item {
    width: 100%;
  }

  .choices__list--multiple {
    display: inline;

    .choices__item {
      display: inline-block;
      vertical-align: middle;
      border-radius: 20px;
      padding: 4px 10px;
      font-size: 12px;
      font-weight: 500;
      margin-right: 3.75px;
      margin-bottom: 3.75px;
      background-color: #00bcd4;
      border: 1px solid #00a5bb;
      color: #ffffff;
      word-break: break-all;
      box-sizing: border-box;

      &[data-deletable] {
        padding-right: 5px;
      }
    }
  }

  [dir='rtl'] .choices__list--multiple .choices__item {
    margin-right: 0;
    margin-left: 3.75px;
  }

  .choices__list--multiple .choices__item.is-highlighted {
    background-color: #00a5bb;
    border: 1px solid #008fa1;
  }

  .is-disabled .choices__list--multiple .choices__item {
    background-color: #aaaaaa;
    border: 1px solid #919191;
  }

  .choices__list--dropdown {
    visibility: hidden;
    z-index: 1;
    position: absolute;
    width: 100%;
    background-color: #ffffff;
    border: 1px solid #dddddd;
    top: 100%;
    margin-top: -1px;
    border-bottom-left-radius: 2.5px;
    border-bottom-right-radius: 2.5px;
    overflow: hidden;
    word-break: break-all;
    will-change: visibility;

    &.is-active {
      visibility: visible;
    }
  }

  .is-open .choices__list--dropdown {
    border-color: #b7b7b7;
  }

  .is-flipped .choices__list--dropdown {
    top: auto;
    bottom: 100%;
    margin-top: 0;
    margin-bottom: -1px;
    border-radius: 0.25rem 0.25rem 0 0;
  }

  .choices__list--dropdown {
    .choices__list {
      position: relative;
      max-height: 300px;
      overflow: auto;
      -webkit-overflow-scrolling: touch;
      will-change: scroll-position;
    }

    .choices__item {
      position: relative;
      padding: 10px;
      font-size: 14px;
    }
  }

  [dir='rtl'] .choices__list--dropdown .choices__item {
    text-align: right;
  }

  .choices__list--dropdown .choices__item--selectable.is-highlighted {
    background-color: #f2f2f2;

    &:after {
      opacity: 0.5;
    }
  }

  .choices__item {
    cursor: default;
  }

  .choices__item--selectable {
    cursor: pointer;
  }

  .choices__item--disabled {
    cursor: not-allowed;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
    opacity: 0.5;
  }

  .choices__heading {
    font-weight: 600;
    font-size: 12px;
    padding: 10px;
    border-bottom: 1px solid #f7f7f7;
    color: gray;
  }

  .choices__button {
    text-indent: -9999px;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    border: 0;
    background-color: transparent;
    background-repeat: no-repeat;
    background-position: center;
    cursor: pointer;

    &:focus {
      outline: none;
    }
  }

  .choices__input {
    display: inline-block;
    vertical-align: baseline;
    background-color: #f9f9f9;
    font-size: 14px;
    margin-bottom: 5px;
    border: 0;
    border-radius: 0;
    max-width: 100%;
    padding: 4px 0 4px 2px;

    &:focus {
      outline: 0;
    }
  }

  [dir='rtl'] .choices__input {
    padding-right: 2px;
    padding-left: 0;
  }

  .choices__placeholder {
    opacity: 0.5;
  }

  .tab-heading, .tab-subheading {
    margin-bottom: 20px;

    font-size: 1.2rem;
    font-weight: 700;
  }

  .tab-subheading {
    font-size: 1rem;
  }

  .rangeselection {
    display: block;
    margin-bottom: 10px;
  }

  .resetFilter {
    cursor: pointer;
    margin-top: 10px;
  }

  .range {
    width: 100%;
  }

  #vehiclesearch {
    margin-bottom: 40px;
  }

  .select-comp {
    width: 100%;
    margin-bottom: 12px;
  }

  .select-style .select-comp {
    width: 100%;
    margin-right: 0;
  }

  .vehicle {
    .content {
    }

    .images {

      ul, li, figure {
        margin: 0;
        padding: 0;
        list-style: none;
      }

      img {
        width: 100%;
        height: auto;
      }

      button img {
        width: 10px;
        height: 16px;
      }
    }

    h2 {
      font-size: 18px;
      color: #222;
      margin-top: 0;
      text-decoration: none;

      a {
        font-size: 18px;
        color: #222;
        margin-top: 0;
        text-decoration: none;
      }

      small {
        font-size: 14px;
        display: block;
        font-weight: 500;
        color: #959899;
      }

      margin-bottom: 0;
      text-align: left;
    }
  }

  .vehicle-detail {
    h1, h2 {
      margin-bottom: 0;
      text-align: left;
    }
  }

  #v-search {
    h2 {
      width: 70%;
      float: left;
    }

    .tabs-details h2 {
      float: none;
      width: 100%;
    }
  }

  #vehicle-sorting {
  }
}

@media (min-width: 640px) {
  #vehicle__search {
    .choices__list--dropdown .choices__item--selectable {
      padding-right: 100px;

      &:after {
        content: attr(data-select-text);
        font-size: 12px;
        opacity: 0;
        position: absolute;
        right: 10px;
        top: 50%;
        transform: translateY(-50%);
      }
    }

    [dir='rtl'] .choices__list--dropdown .choices__item--selectable {
      text-align: right;
      padding-left: 100px;
      padding-right: 10px;

      &:after {
        right: auto;
        left: 10px;
      }
    }
  }
}

section #vehicle__search {
  h2:after, .vehicle-detail h1:after {
    display: none;
    content: "";
  }
}

#vehicle__search {
  .tabs:after, .ranges:after, .checkbox-category:after, .vehicle .services:after, .vehicle-detail .services:after, .c:after, .tabs ul:after {
    clear: both;
    content: "";
    display: block;
  }

  .checkbox-category {
    margin-bottom: 30px;
  }

  .tabs {
    margin-top: 30px;
  }

  .equipment-item {
  }

  .tabs ul {
    margin: 5px 0 0px 0;
    padding: 0;
    list-style: none;

    li {
      margin: 0 10px 10px 0;
      padding: 12px 24px;
      background: #efefef;
      list-style: none;
      float: left;

      a {
        text-decoration: none !important;
      }

      &.is-active {
        background: #111;
        color: #fff;

        a {
          color: #fff !important;
        }
      }

      a {
        display: block;
        color: #222;
        text-decoration: none;
      }
    }
  }

  .tabs-details {
    > div {
      padding: 40px;
      margin: 20px 0;
      border: 1px solid #dadada;
    }

    h3 {
      margin-bottom: 20px;
    }
  }

  .form-attribute {
    padding: 4px 10px;
    background: #fcc312;
    color: #111;
    font-size: 12px;
    margin: 10px 10px 10px 0px;
    display: inline-block;
    cursor: pointer;
  }

  .submitSearchResults {
    float: right;
    margin-top: 40px;
  }

  .check-ctn {
    label {
      line-height: 15px;
      padding-left: 22px;
      vertical-align: top;
      font-size: 1rem;
    }

    display: block;
    position: relative;
    cursor: pointer;
    vertical-align: middle;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;

    input {
      position: absolute;
      opacity: 0;
      cursor: pointer;
      height: 0;
      width: 0;
    }
  }

  .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    vertical-align: middle;
    height: 15px;
    width: 15px;
    border: 1px solid #ccc;
  }

  .check-ctn input:checked ~ .checkmark {
    border-color: #222;
  }

  .checkmark:after {
    content: "";
    position: absolute;
    display: none;
  }

  .check-ctn {
    input:checked ~ .checkmark:after {
      display: block;
    }

    .checkmark:after {
      left: 4px;
      top: 2px;
      width: 3px;
      height: 6px;
      border: solid #222;
      border-width: 0 3px 3px 0;
      -webkit-transform: rotate(45deg);
      -ms-transform: rotate(45deg);
      transform: rotate(45deg);
    }
  }

  .exteriorColor .check-ctn:hover input ~ .checkmark, .interiorColor .check-ctn:hover input ~ .checkmark, .exteriorColor .checkmark {
    border: none;
  }

  .interiorColor {
    .checkmark {
      border: none;
    }

    .check-ctn .checkmark:after {
      border: solid white;
      border-width: 0 3px 3px 0;
    }
  }

  .exteriorColor .check-ctn .checkmark:after {
    border: solid white;
    border-width: 0 3px 3px 0;
  }

  .vehicle-general-icons .icon {
    &.exteriorColor .ico.black, &.interiorColor .ico.black {
      background: #000;
    }
  }

  .check-ctn.color-item.black {
    .checkmark, input:checked ~ .checkmark {
      background: #000;
    }
  }

  .vehicle-general-icons .icon {
    &.exteriorColor .ico.other_interior_color, &.interiorColor .ico.other_interior_color {
      background: #efefef;
    }
  }

  .check-ctn.color-item.other_interior_color {
    .checkmark, input:checked ~ .checkmark {
      background: #efefef;
    }
  }

  .vehicle-general-icons .icon {
    &.exteriorColor .ico.grey, &.interiorColor .ico.grey {
      background: #666666;
    }
  }

  .check-ctn.color-item.grey {
    .checkmark, input:checked ~ .checkmark {
      background: #666666;
    }
  }

  .vehicle-general-icons .icon {
    &.exteriorColor .ico.beige, &.interiorColor .ico.beige {
      background: #ddc8c1;
    }
  }

  .check-ctn.color-item.beige {
    .checkmark, input:checked ~ .checkmark {
      background: #ddc8c1;
    }
  }

  .vehicle-general-icons .icon {
    &.exteriorColor .ico.brown, &.interiorColor .ico.brown {
      background: #984e0a;
    }
  }

  .check-ctn.color-item.brown {
    .checkmark, input:checked ~ .checkmark {
      background: #984e0a;
    }
  }

  .vehicle-general-icons .icon {
    &.exteriorColor .ico.red, &.interiorColor .ico.red {
      background: #fb1a08;
    }
  }

  .check-ctn.color-item.red {
    .checkmark, input:checked ~ .checkmark {
      background: #fb1a08;
    }
  }

  .vehicle-general-icons .icon {
    &.exteriorColor .ico.green, &.interiorColor .ico.green {
      background: #25935c;
    }
  }

  .check-ctn.color-item.green {
    .checkmark, input:checked ~ .checkmark {
      background: #25935c;
    }
  }

  .vehicle-general-icons .icon {
    &.exteriorColor .ico.blue, &.interiorColor .ico.blue {
      background: #004b80;
    }
  }

  .check-ctn.color-item.blue {
    .checkmark, input:checked ~ .checkmark {
      background: #004b80;
    }
  }

  .vehicle-general-icons .icon {
    &.exteriorColor .ico.purple, &.interiorColor .ico.purple {
      background: #800080;
    }
  }

  .check-ctn.color-item.purple {
    .checkmark, input:checked ~ .checkmark {
      background: #800080;
    }
  }

  .vehicle-general-icons .icon {
    &.exteriorColor .ico.gold, &.interiorColor .ico.gold {
      background: #db873a;
    }
  }

  .check-ctn.color-item.gold {
    .checkmark, input:checked ~ .checkmark {
      background: #db873a;
    }
  }

  .vehicle-general-icons .icon {
    &.exteriorColor .ico.white, &.interiorColor .ico.white {
      background: #efefef;
    }
  }

  .check-ctn.color-item.white {
    .checkmark, input:checked ~ .checkmark {
      background: #efefef;
    }
  }

  .vehicle-general-icons .icon {
    &.exteriorColor .ico.orange, &.interiorColor .ico.orange {
      background: #d84d1c;
    }
  }

  .check-ctn.color-item.orange {
    .checkmark, input:checked ~ .checkmark {
      background: #d84d1c;
    }
  }

  .vehicle-general-icons .icon {
    &.exteriorColor .ico.silver, &.interiorColor .ico.silver {
      background: #cccccc;
    }
  }

  .check-ctn.color-item.silver {
    .checkmark, input:checked ~ .checkmark {
      background: #cccccc;
    }
  }

  .vehicle-general-icons .icon {
    &.exteriorColor .ico.yellow, &.interiorColor .ico.yellow {
      background: #ffcc00;
    }
  }

  .check-ctn.color-item.yellow {
    .checkmark, input:checked ~ .checkmark {
      background: #ffcc00;
    }
  }

  #locationScroll {
    font-size: 16px;
    display: block;
    font-weight: 400;
    color: #959899;
    cursor: pointer;

    span {
      text-decoration: underline;
    }
  }

  #locationMap {
    width: 100%;
    height: 400px;
    position: relative;
    background: #eee;
  }

  .infobox {
    color: #fff;
    background: #111;
    padding: 30px;
    position: absolute;

    h3 {
      font-size: 1rem;
      letter-spacing: 0;
      margin: 0;
      background: none;
      text-align: left;
      padding: 0;
      color: #fff;
      margin-bottom: 20px;
    }

    p {
      a {
        color: #fff;
      }

      font-size: 0.9rem;
      margin-bottom: 21px;
    }
  }

  .backToSearch {
    position: relative;
    color: #959899;
    text-decoration: none;
    padding: 8px 0;
    font-size: 0.9rem;
    display: inline-block;

    a {
      color: #959899;
    }
  }

  #vehicle-sorting {
    #sort {
      width: 65%;
      float: right;
    }

    #order {
      width: 64px;
      float: right;

      .sortorder {
        line-height: 46px;
        width: 32px;
        text-align: center;
        display: inline-block;
        cursor: pointer;
      }
    }
  }
}

#mobileTabHandler {
  display: none;
}

@media (max-width: 900px) {
  #vehicle__search {
    .vehicle .l, .vehicle-detail .l {
      margin-bottom: 20px;
    }

    .vehicle .content {
      width: 100%;
    }

    .tabs ul li {
      box-sizing: border-box;
      margin-bottom: 1%;
      text-align: center;
      width: 48%;
      margin-right: 1%;
    }

    .vehicle .images {
      width: 100%;
      margin-right: 0;
      margin-bottom: 30px;
    }

    .equipment-item {
      width: 50%;
    }

    .tabs-details > div {
      padding: 20px;
    }
  }
}

#vehicle__search {
  .backToSearchMobile {
    display: none;
  }

  .financing-list small span {
    display: block;
  }

  .subscriptionButton button {
    margin: 20px 0;
    padding: 0;
    border-top: 3px solid #fcc312 !important;
  }
}

@media (max-width: 600px) {
  #vehicle__search {
    .financing-list-head li, .financing-list li {
      width: 100%;
      display: block;
    }
  }

  section #vehicle__search {
    .financing-list {
      margin-top: 20px;
    }

    .financing-list-head li {
      padding: 0 0 4px 0;
    }

    .financing-list li {
      padding: 0 0 4px 0;

      .showIfMobile {
        font-weight: 600;
        padding-right: 5px;
      }
    }
  }

  #vehicle__search {
    #mobileTabHandler {
      display: block;
      border-top: 1px solid #eee;
      padding-top: 30px;
      margin-top: 30px;

      .select-component {
        &::after {
          z-index: 10;
          color: #fff;
          line-height: 76px;
          font-size: 20px;
        }

        background: #111;
        border: none;
        height: auto;
        box-sizing: border-box;
        padding: 8px 0;
      }

      select {
        color: #fff;
        background: transparent;
        font-size: 20px;
        padding: 0 20px;
      }
    }

    .tabs {
      display: none;
    }

    .vehicle .l, .vehicle-detail .l {
      font-size: 14px;
      box-sizing: border-box;
      padding: 0 20px 0 0;
      margin-right: 0;
      width: 50%;
    }

    .showMore {
      float: none;
    }

    .vehicle h2 {
      margin-top: 0;
    }

    .vehicle-detail {
      h1, h2 {
        margin-top: 0;
      }
    }

    .showMore a {
      background: #efefef;
      color: #111;
    }

    .vehicle-detail .price {
      float: none;
      width: 100%;
      margin-top: 0;
      text-align: left;
    }

    .price .pricing {
      margin-top: 0;
    }

    #v-search h2, #vehicle-sorting, .vehicle-detail .default-info, .feature-col {
      width: 100%;
    }

    #vehicle-sorting #sort {
      float: left;
    }

    .price .vat {
      display: block;
      margin-left: 0;
    }

    .moreVehicles, .showMore .button {
      width: 100%;
      display: block;
      box-sizing: border-box;
      text-align: center;
      margin: 20px 0 0 0;
      font-size: 16px;
      float: none;
    }

    .vehicle .l:nth-child(2n), .vehicle-detail .l:nth-child(2n) {
      border: none;
      padding-left: 20px;
      padding-right: 0;
    }

    .services {
      margin-top: 30px;
      margin-bottom: 0;
    }

    .price-button:last-of-type {
      display: none;
    }

    .infobox h3 {
    }

    .pricing-buttons {
      margin-bottom: 30px;
    }

    .general-infos {
      margin-top: 20px;
    }

    .vehicle-detail h1 {
      font-size: 24px;
    }

    .backToSearch {
      display: none;
    }

    .vehicle-detail hr {
      margin: 20px 0;
    }

    .imageList {
      .slide {
        width: 50%;

        &:nth-child(3), &:nth-child(4), &:nth-child(5), &:nth-child(6) {
          width: 25%;
        }
      }

      #showAllPhotos {
        position: static;
        display: block;
        box-sizing: border-box;
        text-align: right;
        font-size: 13px;
        width: 50%;
        padding: 10px 0;
        float: left;
      }
    }

    .backToSearchMobile {
      display: block;
      font-size: 13px;
      width: 50%;
      padding: 10px 0;
      float: left;
      text-align: left;
      color: #111;
    }

    .price-button {
      box-sizing: border-box;
      display: block;
      text-align: center;
      margin-left: 0;
      float: left;
      width: 58%;
      margin-right: 4%;

      &:nth-child(2n) {
        margin-right: 0;
        width: 38%;
      }
    }

    .infobox p {
      font-size: 0.8rem;
    }

    .vehicle-general-icons {
      .icon {
        padding: 20px 10px;
        display: inline-block;
        width: 50%;
        box-sizing: border-box;
        vertical-align: top;
      }

      .icon-label {
        font-size: 14px;
      }
    }

    select, .input-field input {
      font-size: 0.9rem;
      box-sizing: border-box;
    }

    .vehicle-general-icons .icon-desc {
      font-size: 16px;

      span {
        font-size: 16px;
      }
    }

    .select-comp, .input-field {
      float: none;
      margin-bottom: 12px;
    }


    .checkbox-category {
      margin-bottom: 0;
    }

    .tabs-details h3 {
      margin-bottom: 10px;
      margin-top: 30px;
      font-size: 1.2rem;
    }
  }

  section #vehicle__search form h2 {
    font-size: 1.3rem;
  }

  #vehicle__search {
    .select-comp, .input-field input, .equipment-item {
      width: 100%;
      margin-right: 0;
    }

    .check-ctn {
      .checkmark:after {
        left: 6px;
        top: 2px;
      }

      label {
        padding-left: 30px;
      }
    }

    .checkmark {
      width: 20px;
      height: 20px;
    }

    .range {
      width: 94%;
      margin-right: 0;
    }

    .check-ctn label {
      font-size: 0.8rem;
    }

    .equipment-item.color-item {
      width: 50%;
    }

    .resetFilter {
      width: 100%;
    }
  }
}

.select-grid {

  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 12px;
}

.aside__handler {
  display: grid;
  margin-bottom: 30px;
  grid-template-columns: 1fr 1fr 0.5fr 1.5fr;
  grid-template-areas:
    "formResult formResult formResult formAction"
    "formSelection formSelection formSelection formSelection";
}

.formSelection {
  grid-area: formSelection;
}

.formResult {
  grid-area: formResult;
}

.formAction {
  grid-area: formAction;
}

</style>


